module.exports = function(service) {
	'use strict'
	service.factory('jwtDecoderService', jwtDecoderService);
	jwtDecoderService.$inject = [];
	
	function jwtDecoderService() {
		var jwtDecoder = {
			// Decode JWT token and return payload
			decodeToken: function(token) {
				if (!token) {
					return null;
				}
				
				try {
					// Split the token into parts
					var parts = token.split('.');
					if (parts.length !== 3) {
						return null;
					}
					
					// Decode the payload (second part)
					var payload = parts[1];
					
					// Add padding if needed
					while (payload.length % 4) {
						payload += '=';
					}
					
					// Decode base64 and parse JSON
					var decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
					return JSON.parse(decodedPayload);
				} catch (error) {
					console.error('Error decoding JWT token:', error);
					return null;
				}
			},
			
			// Get expiration date from token
			getExpirationDate: function(token) {
				var payload = this.decodeToken(token);
				if (!payload || !payload.exp) {
					return null;
				}
				
				// Convert Unix timestamp to Date object
				return new Date(payload.exp * 1000);
			},
			
			// Check if token is expired
			isTokenExpired: function(token) {
				var expirationDate = this.getExpirationDate(token);
				if (!expirationDate) {
					return true; // Consider invalid tokens as expired
				}
				
				return new Date() > expirationDate;
			},
			
			// Get time until expiration in milliseconds
			getTimeUntilExpiration: function(token) {
				var expirationDate = this.getExpirationDate(token);
				if (!expirationDate) {
					return 0;
				}
				
				return expirationDate.getTime() - new Date().getTime();
			},
			
			// Get user ID from token
			getUserId: function(token) {
				var payload = this.decodeToken(token);
				return payload ? payload.user_id || payload.sub || payload.id : null;
			},
			
			// Get all claims from token
			getClaims: function(token) {
				return this.decodeToken(token);
			}
		};
		
		return jwtDecoder;
	}
} 


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/jwtDecoderService.js
// module id = 611
// module chunks = 0